//@ts-expect-error нет d.ts
import emitter from 'tiny-emitter/instance';
import type { App } from 'vue';
import type { Events } from './events';


interface EventBus<T extends Record<keyof T, (...args: any) => any>> {
  $on<E extends keyof T>(event: E, handler: T[E]): void;
  $off<E extends keyof T>(event: E, handler: T[E]): void;
  $once<E extends keyof T>(event: E, handler: T[E]): void;
  $emit<E extends keyof T>(event: E, ...payload: Parameters<T[E]>): ReturnType<T[E]>;
}

const eventBus: EventBus<Events> = {
  $on: (...args: any) => emitter.on(...args),
  $once: (...args: any) => emitter.once(...args),
  $off: (...args: any) => emitter.off(...args),
  $emit: (...args: any) => emitter.emit(...args),
};

export default eventBus;

export function useEventBus() {
  return eventBus;
}

export function EventBusSetup(app: App<Element>) {
  app.config.globalProperties.$eventBus = eventBus;
  app.config.globalProperties.$event = eventBus;
}
